import { MutableRefObject, useEffect, useRef } from "react";
import L from "leaflet";
import { TargetLocation } from "../dtos/TargetLocation";

interface UseRouteLineOptions {
  mapInst: MutableRefObject<L.Map | null>;
  mapReady: boolean;
  coords: [number, number] | null;
  targetLocation: TargetLocation | null;
  accentColor?: string;
}

export const useRouteLine = ({ mapInst, mapReady, coords, targetLocation, accentColor = "#2563eb" }: UseRouteLineOptions) => {
  const lineRef = useRef<L.Polyline | null>(null);
  const dotRef = useRef<L.CircleMarker | null>(null);

  useEffect(() => {
    const map = mapInst.current;

    // ── Dọn layer cũ
    lineRef.current?.remove();
    lineRef.current = null;
    dotRef.current?.remove();
    dotRef.current = null;

    if (!map || !mapReady || !coords || !targetLocation) return;

    const [curLat, curLng] = coords;

    // ── Dot GPS hiện tại
    dotRef.current = L.circleMarker([curLat, curLng], {
      radius: 7,
      color: accentColor,
      fillColor: accentColor,
      fillOpacity: 0.22,
      weight: 2,
      opacity: 0.85,
    }).addTo(map);

    
  }, [mapInst, mapReady, coords, targetLocation, accentColor]);

  // Cleanup khi unmount
  useEffect(
    () => () => {
      lineRef.current?.remove();
      dotRef.current?.remove();
    },
    [],
  );
};
